import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import loadable from "@loadable/component";
import { useIsIntersecting, useModal, useTestId } from "@/hooks";
import { ModalIds } from "@/constants";
import { Section, Title } from "@/components/UI";
import { useI18n } from "@/contexts/i18n";
import { useRefsContext } from "@/contexts/ref";
const Location = loadable(() => import("../Location/Location"), {
    resolveComponent: (components) => components.Location,
});
export const LocationLazy = () => {
    const { isIntersecting } = useIsIntersecting({
        elementId: "location",
        rootMargin: "500px",
        triggerOnce: true,
    });
    const { locationRef } = useRefsContext();
    const testId = useTestId("Sections.Location");
    const { t } = useI18n();
    const { isOpen } = useModal(false, ModalIds.MAP);
    const shouldLoad = isIntersecting || isOpen;
    return (_jsxs(Section, { ref: locationRef, id: "location", testId: testId, children: [_jsx(Title, { title: t("description.block.area.headline"), testId: `${testId}.Title`, variant: "section", hasMargin: true }), shouldLoad ? _jsx(Location, {}) : _jsx(_Fragment, {})] }));
};
